import { defineStore } from "pinia"
import { HelpLabelClient } from "../../entities/NSwagGenerated"

interface HelpLabelEntry {
	tooltip: string | null
	hasHelpText: boolean
}

interface HelpLabelState {
	labels: Map<string, HelpLabelEntry>
}

export const useHelpLabelStore = defineStore("helpLabel", {
	state: (): HelpLabelState => ({
		labels: new Map<string, HelpLabelEntry>(),
	}),

	actions: {
		async loadAll(): Promise<void> {
			const client = new HelpLabelClient(import.meta.env.VITE_API_URL?.toString())
			const items = await client.list()
			const map = new Map<string, HelpLabelEntry>()
			for (const item of items) {
				if (!item.helpElementName) continue
				if (item.tooltip || item.hasHelpText) {
					map.set(item.helpElementName, {
						tooltip: item.tooltip ?? null,
						hasHelpText: item.hasHelpText ?? false,
					})
				}
			}
			this.labels = map
		},

		updateTooltip(helpElementName: string, tooltip: string | null): void {
			const existing = this.labels.get(helpElementName)
			if (existing) {
				existing.tooltip = tooltip
			} else {
				this.labels.set(helpElementName, { tooltip, hasHelpText: false })
			}
		},

		updateHelpText(helpElementName: string, hasHelpText: boolean): void {
			const existing = this.labels.get(helpElementName)
			if (existing) {
				existing.hasHelpText = hasHelpText
			} else {
				this.labels.set(helpElementName, { tooltip: null, hasHelpText })
			}
		},
	},

	getters: {
		getTooltip:
			(state) =>
			(helpElementName: string): string | null => {
				return state.labels.get(helpElementName)?.tooltip ?? null
			},

		hasHelpText:
			(state) =>
			(helpElementName: string): boolean => {
				return state.labels.get(helpElementName)?.hasHelpText ?? false
			},
	},
})
